import React from "react";
import "../csscontainer/Footer.css";
import "../App.css";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import Text from "../components/Text";
import TextBox from "../components/TextBox";
import { TEXT } from "../utility/constants";
import diverseServicesImage from "../assets/images/services_top.png"; // ASSUMPTION: Update the path to your provided image
import fibre from "../assets/images/fiber.png"; // ASSUMPTION: Update the path to your provided image
import cable from "../assets/images/cable.png"; // ASSUMPTION: Update the path to your provided image

function ItServices() {
  const servicesData = TEXT.coverageDataForITServices;
   return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        {/* --- NEW SECTION FOR IMAGE ON RIGHT AND TEXT ON LEFT --- */}
        <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.ITServicesHeading}
            </Text>
          
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.ITServicesDescription}
            </Text>
           
          </div>
          <div className="service-intro-image">
            <img
              src={diverseServicesImage} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>


         <div className="service-intro-section">

          <div className="service-intro-image">
            <img
              src={cable} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.cablingHeading}
            </Text>
          
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.cablingDesc}
            </Text>
           
          </div>
          
        </div>


         <div className="service-intro-section">
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.fiberHeading}
            </Text>
          
            <Text
              color="#364040FF"
              size="18px"
              weight="normal"
              align="start"
              style={{ lineHeight: "1.6" }}
            >
              {TEXT.fiberDesc}
            </Text>
           
          </div>
          <div className="service-intro-image">
            <img
              src={fibre} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
        </div>
        
       
       <div className="coverage-table-container"style={{ marginTop: "40px", marginBottom: "40px" }}>
          <h3>{TEXT.ITServicesSubHeading}</h3>
          <h4 style={{marginBottom:"40px"}}>{TEXT.ITServicesSubHeading2}</h4>
          <table className="coverage-table">
            <thead>
              <tr>
                <th>Other Services</th>
                <th>Ideal For</th> 
              </tr>
            </thead>
            <tbody>
              {servicesData.map((item, index) => (
                <tr key={index}>
                  <td data-label="Coverage Type" className="tier-name">
                    {item.heading}
                  </td>
                  
                  <td data-label="Description" className="tier-description">
                    {item.description}
                  </td>{" "}
                  {/* NEW DATA CELL */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>


        <Footer />
      </div>
    </motion.div>);
}
export default ItServices;